import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobilePhone } from '@fortawesome/free-solid-svg-icons';

const CallMe = () => {
    return(
        <>
            <div className="call-me droitiers">
                <h2>
                    <a href="tel:0750688243">
                        <span><FontAwesomeIcon icon={faMobilePhone} /></span>
                        <span>0750 688 243</span>
                    </a>
                </h2>
            </div>
        </>
    );
};

export default CallMe;